#ifdef USE_DISSOLVE
    if (lastEvent > 4) {
        float n = texture2D(dissolveTexture,  vUv).x - dissolveValue;

        if(n < 0.0) { discard; }
    }
#endif
